export default [
    {
        path: '/:cid/personal-task',
        name: 'PersonalTask',
        meta: {
            title: "Personal Task",
            requiresAuth: true
        },
        component: () => import('@/views/PersonalTask/PersonalTask.vue'),
    },
    {
        path: '/:cid/my-daily-task',
        name: 'MyDailyTask',
        meta: {
            title: "My Daily Task",
            requiresAuth: true
        },
        redirect: to => ({
            name: "PersonalTask",
            params: { cid: to.params.cid },
            query: to.query,
        }),
    },
]
